/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { CampaignCopyPathParams, CampaignCopyRequest, CampaignCopyResponse } from '../types/CampaignCopy'

/**
 * POST /campaigns/:campaign/copy
 * @see backend/nexus/modules/Campaign/Http/Controllers/CampaignController.php CampaignController::copy
 */
export async function campaignCopy(
	campaign: CampaignCopyPathParams['campaign'],
	data: CampaignCopyRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<CampaignCopyResponse>> {
	return axiosInstance.post(`/campaigns/${campaign}/copy`, data, config)
}
